<template>
  <v-dialog v-model="showModal" persistent max-width="500px">
    <v-card class="mx-auto">
      <v-card-title class="title font-weight-regular justify-space-between">
        <span>{{ currentTitle }}</span>
        <v-chip small="" color="blue" class="white--text"
          >{{ step }} / 4</v-chip
        >
      </v-card-title>
      <v-window v-model="step">
        <!-- Pick Course -->

        <v-window-item :value="1">
          <v-card-text>
            <v-form ref="form">
              <v-autocomplete
                label="Course"
                autocomplete="off"
                :items="courseNames"
                :loading="isLoading"
                :rules="rules.course"
                :disabled="isLoading"
                :item-text="obj => obj.name"
                :item-value="obj => obj"
                v-model="form.course"
              ></v-autocomplete>
            </v-form>
            <span class="caption grey--text text--darken-1">
              This is the course that will gain another enrollment option for
              your users.
            </span>
          </v-card-text>
        </v-window-item>
        <!-- Course properties -->
        <v-window-item :value="2">
          <v-card flat>
            <!-- <v-select
                :items="prices"
                label="Price"
                :value="100"
                v-model="form.properties.priceObject"
                :item-text="showPrice"
                :item-value="obj => obj"
              >
              </v-select> -->
            <!-- <span class="subtitle-1">Price</span> -->
            <v-card-text
              ><span class="body-1">Price</span>
              <v-text-field
                class="mt-0 pt-0"
                min="0"
                prefix="$"
                max="120"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                type="number"
                step="1"
                :rules="pricerules"
                v-model="form.properties.price"
              ></v-text-field
            ></v-card-text>
          </v-card>
          <v-card flat>
            <v-card-text class="body-1 mb-0 pb-0 pt-1">
              Allow users to anonymously enroll with just a phone number? (Note: You will not have access
              to any identifiable information about users with this option.)
              <v-switch
                class="pa-0 ma-0 mt-2"
                :disabled="form.properties.price > 0"
                :label="form.properties.allowAnonymousUsers ? 'Yes' : 'No'"
                color="blue"
                v-model="form.properties.allowAnonymousUsers"
              ></v-switch>
            </v-card-text>
          </v-card>
          <v-card flat>
            <v-card-text class="body-1 mb-0 pb-0 pt-1">
              Make accessible through share link only?
              <v-switch
                class="pa-0 ma-0 mt-2"
                :label="form.properties.hidden ? 'Yes' : 'No'"
                color="blue"
                v-model="form.properties.hidden"
              ></v-switch>
            </v-card-text>
          </v-card>
          <v-card flat class="d-none d-md-flex">
            <v-card-text class="body-1 mb-0 pb-0 pt-1 pb-2">
              What days should Arist skip sending messages?
              <v-btn-toggle
                v-model="form.properties.skipDays"
                multiple
                color="red"
                style="width:100%"
                class="mt-2"
              >
                <v-btn
                  :disabled="
                    !form.properties.skipDays.includes(item) &&
                      form.properties.skipDays.length >= MAX_SKIP_DAYS
                  "
                  :width="`${100 / daySelections.length}%`"
                  v-for="item in daySelections"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </v-btn>
              </v-btn-toggle>
              <span
                class="red--text caption"
                v-if="form.properties.skipDays.length >= MAX_SKIP_DAYS"
                >You have reached the maximum amount of skippable days.</span
              >
            </v-card-text>
          </v-card>
          <v-card flat>
            <v-card-text class="body-1 mb-0 pb-0 pt-1">
              Require an access code to enroll?
              <v-switch
                class="pa-0 ma-0 mt-2"
                :label="form.properties.requireAccessCode ? 'Yes' : 'No'"
                color="blue"
                v-model="form.properties.requireAccessCode"
              ></v-switch>
              <v-slide-y-transition>
                <v-text-field
                  v-if="form.properties.requireAccessCode"
                  v-model="form.properties.accessCode"
                  label="Access Code"
                ></v-text-field>
              </v-slide-y-transition>
            </v-card-text>
          </v-card>
        </v-window-item>
        <!-- Review and create -->
        <v-window-item :value="3">
          <v-card flat="" class="pa-0 ma-0">
            <v-list-item three-line>
              <v-list-item-avatar tile size="110px">
                <v-img
                  :src="form.course.imglink"
                  max-height="110"
                  contain
                  position="left"
                ></v-img>
              </v-list-item-avatar>
              <v-list-item-content class="pb-1">
                <v-list-item-title class="headline">{{
                  form.course.name || "No name"
                }}</v-list-item-title>
                <v-list-item-title class="subtitle-1 font-weight-regular">
                  <b>Price: </b
                  >{{
                    form.properties.price == 0
                      ? "Free"
                      : "$" + form.properties.price
                  }}
                </v-list-item-title>
                <v-list-item-title class="subtitle-1 font-weight-regular">
                  <b>Phone Only Accounts: </b>
                  {{
                    form.properties.allowAnonymousUsers
                      ? "Allowed"
                      : "Not allowed"
                  }}
                </v-list-item-title>
                <v-list-item-title class="subtitle-1 font-weight-regular">
                  <b>Accessible: </b>
                  {{
                    form.properties.hidden
                      ? "Only with share URL"
                      : "By front page"
                  }}
                </v-list-item-title>
                <v-list-item-title class="subtitle-1 font-weight-regular">
                  <b>Access Code: </b>
                  {{
                    form.properties.requireAccessCode
                      ? `Required - ${form.properties.accessCode}`
                      : "Not needed"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-window-item>
        <v-window-item :value="4">
          <v-card flat="" class="pa-0 ma-0">
            <v-card-text>
              Share this course to your social media!
            </v-card-text>
            <v-card-text>
              <span ref="copyText">{{ courseurl }}</span>
            </v-card-text>
            <v-card-text>
              <div class="d-flex">
                <v-btn
                  :href="twitterlink"
                  target="__twittershare__"
                  color="#1DA1F2"
                  class="white--text"
                  depressed=""
                  width="140px"
                >
                  <v-icon>mdi-twitter</v-icon>Twitter
                </v-btn>
                <v-spacer />
                <v-btn
                  :href="facebooklink"
                  target="__facebook__"
                  color="#4267B2"
                  class="white--text"
                  depressed=""
                  width="140px"
                >
                  <v-icon>mdi-facebook</v-icon>Facebook
                </v-btn>
              </div>
              <!-- https://www.facebook.com/sharer/sharer.php?u=example.org -->
            </v-card-text>
          </v-card>
        </v-window-item>
      </v-window>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          :disabled="step === 4"
          depressed
          color="grey white--text"
          @click="getBack()"
          min-width="100px"
        >
          {{ step > 1 ? "Back" : "Cancel" }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="isDisabled || isSaving"
          :loading="isSaving"
          color="primary"
          depressed
          @click="nextStep()"
          min-width="100px"
        >
          {{ step == 3 ? "Save and Share" : step == 4 ? "Exit" : "Next" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import services from "@/services/index.js";
export default {
  props: ["dialog"],
  data: () => ({
    MAX_SKIP_DAYS: 6,
    daySelections: ["sun", "mon", "tue", "wed", "thu", "fri", "sat"],
    prices: [],
    results: null,
    isLoading: false,
    isSaving: false,
    step: 1,
    courses: [],
    rules: {
      course: [v => !!v || "Course is required"]
    },
    pricerules: [
      value => value != undefined || "Required.",
      value => (value || 0) < 120 || "Max price 120 dollars.",
      value => value >= 0 || "Price must be postive."
    ],
    form: {
      course: {
        name: ""
      },
      properties: {
        allowAnonymousUsers: false,
        requireAccessCode: false,
        accessCode: "",
        hidden: false,
        skipDays: [],
        priceObject: null,
        price: 0
      }
    },
    cleanForm: {
      course: {
        name: ""
      },
      properties: {
        allowAnonymousUsers: false,
        requireAccessCode: false,
        accessCode: "",
        skipDays: [],
        hidden: false,
        priceObject: null,
        price: 0
      }
    }
  }),
  computed: {
    courseurl() {
      let url = `https://${JSON.parse(
        JSON.stringify(this.$store.getters.getOrganization.subdomain)
      )}.arist.co/courses/${this.results ? this.results._id : "error"}${
        this.form.properties.accessCode &&
        this.form.properties.requireAccessCode
          ? "?accesscode=" + encodeURI(this.form.properties.accessCode)
          : ""
      }`;
      return url;
    },
    facebooklink() {
      let url = `https://${JSON.parse(
        JSON.stringify(this.$store.getters.getOrganization.subdomain)
      )}.arist.co/courses/${this.results ? this.results._id : "error"}${
        this.form.properties.accessCode &&
        this.form.properties.requireAccessCode
          ? "?accesscode=" + encodeURI(this.form.properties.accessCode)
          : ""
      }`;
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(url)}`;
    },
    twitterlink() {
      let text = `I just launched a text message course called "${this.form.course.name}". Check it out: `;
      let url = `https://${JSON.parse(
        JSON.stringify(this.$store.getters.getOrganization.subdomain)
      )}.arist.co/courses/${this.results ? this.results._id : "error"}${
        this.form.properties.accessCode &&
        this.form.properties.requireAccessCode
          ? "?accesscode=" + encodeURI(this.form.properties.accessCode)
          : ""
      }`;

      return `https://twitter.com/intent/tweet?ref_src=twsrc%5Etfw&text=${encodeURI(
        text
      )}&tw_p=tweetbutton&url=${encodeURI(url)}&via=learnarist`;
    },
    currentTitle() {
      switch (this.step) {
        case 1:
          // GA Analytics
          if (this.dialog) {
            try {
              this.$ga.event({
                eventCategory: "dashboard-delivery",
                eventAction: "select-course",
                eventLabel: "Dashboard"
              });
            } catch (err) {
              console.error("[GA]", err);
            }
          }
          // End GA Analytics
          return "Select Course";
        case 2:
          try {
            this.$ga.event({
              eventCategory: "dashboard-delivery",
              eventAction: "enrollment-options",
              eventLabel: "Dashboard"
            });
          } catch (err) {
            console.error("[GA]", err);
          }
          return "Enrollment Options";
        case 3:
          try {
            this.$ga.event({
              eventCategory: "dashboard-delivery",
              eventAction: "review and save",
              eventLabel: "Dashboard"
            });
          } catch (err) {
            console.error("[GA]", err);
          }
          return "Review and Save";
        case 4:
          try {
            this.$ga.event({
              eventCategory: "dashboard-delivery",
              eventAction: "share",
              eventLabel: "Dashboard"
            });
          } catch (err) {
            console.error("[GA]", err);
          }
          return "Share Course";
        default:
          return "Share Course";
      }
    },
    showModal() {
      return this.dialog;
    },
    courseNames() {
      return this.courses.map(course => {
        return course;
      });
    },
    isDisabled() {
      switch (this.step) {
        case 1:
          if (
            this.form.course._id == undefined ||
            this.form.course._id == null
          ) {
            return true;
          } else {
            return false;
          }
        case 2:
          if (
            this.form.properties.price == null ||
            this.form.properties.price < 0 ||
            this.form.properties.price >= 120 ||
            Number.isNaN(Number(this.form.properties.price))
          ) {
            return true;
          } else {
            return false;
          }
        case 3:
          return false;
        case 4:
          return false;
        default:
          return true;
      }
    }
  },
  watch: {
    dialog() {
      if (this.dialog === false) {
        this.form = JSON.parse(JSON.stringify(this.cleanForm));
        this.$refs.form.resetValidation();
        this.step = 1;
      }
    },
    "form.properties.price": function() {
      if (this.form.properties.price > 0) {
        this.form.properties.allowAnonymousUsers = false;
      }
      console.log(this.form.properties.price);
    }
  },
  methods: {
    getBack() {
      if (this.step > 1) {
        this.step--;
        return;
      }
      this.$emit("cancel");
      this.form = JSON.parse(JSON.stringify(this.cleanForm));
      this.$refs.form.resetValidation();
      this.step = 1;
      this.isSaving = false;
    },
    nextStep() {
      if (this.step == 3) {
        this.save();
        return;
      }
      if (this.step >= 4) {
        this.form = JSON.parse(JSON.stringify(this.cleanForm));
        this.$refs.form.resetValidation();
        this.step = 1;
        this.$emit("finish");
        return;
      }
      this.step++;
    },
    async save() {
      if (this.isSaving) {
        return;
      }
      this.isSaving = true;
      this.$store.commit("setLoading", true);
      try {
        let results = await services.delivery.create({
          type: "public",
          course: this.form.course._id,
          properties: {
            price: this.form.properties.price,
            requireAccessCode: this.form.properties.requireAccessCode,
            accessCode: this.form.properties.accessCode,
            skipDays: this.form.properties.skipDays,
            limitCopies: false,
            hidden: this.form.properties.hidden,
            allowAnonymousUsers: this.form.properties.allowAnonymousUsers,
            copies: 100
          }
        });
        console.log(results);
        this.results = results;
        this.$store.commit("setLoading", false);
        this.isSaving = false;
        this.step++;
      } catch (err) {
        this.isSaving = false;
        this.$store.commit("setLoading", false);
      }
      try {
        window.analytics.track("Distribution Created");
        this.$ga.event({
          eventCategory: "dashboard-delivery",
          eventAction: "save",
          eventLabel: "Dashboard"
        });
      } catch (err) {
        console.log(err);
      }
    },
    async onLoad() {
      this.isLoading = true;
      let courses = await services.delivery.get({ type: "approved" });
      this.prices = await this.getPricing();
      this.courses = courses;
      this.isLoading = false;
    },
    showPrice(priceobject) {
      if (priceobject == null) {
        return "";
      }
      return `Tier ${priceobject.tier} - ${
        Number(priceobject.price) > 0 ? "$" + String(priceobject.price) : "Free"
      }`;
    },
    async getPricing() {
      return Promise.resolve([
        { tier: 0, price: 0 },
        { tier: 1, price: 3 },
        { tier: 2, price: 6 },
        { tier: 3, price: 9 },
        { tier: 4, price: 12 },
        { tier: 5, price: 15 },
        { tier: 6, price: 18 },
        { tier: 7, price: 25 },
        { tier: 8, price: 30 },
        { tier: 9, price: 40 },
        { tier: 10, price: 60 },
        { tier: 11, price: 90 },
        { tier: 12, price: 120 }
      ]);
    },
    makeid(length) {
      var result = "";
      var characters = "ABCDEFGHIJKLMNPQRSTUVWXYZ123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    }
  },
  mounted() {
    this.onLoad();
    this.form.properties.accessCode = this.makeid(4);
  }
};
</script>
